import React, { type FC } from 'react';
import { Text, TextButton } from '@wix/design-system';
import { DataHooks } from '../../../constants/dataHooks';
import css from '../TemplatePage.scss';
import { useTranslation } from '@wix/wix-i18n-config';
import type {
  AppTemplate,
  Tag as TemplateTag,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import { useTemplatesPageBi } from '../../../hooks/useTemplatesPageBi';

type Props = {
  template: AppTemplate;
};
export const DescriptionTags: FC<Props> = ({ template }) => {
  const { t } = useTranslation();
  const tags = template?.tags;
  const { reportTagClicked } = useTemplatesPageBi();

  const onTagClicked = (tag: TemplateTag) => {
    reportTagClicked(template.id, tag.title, tag.url);
    tag?.url && window.open(tag.url);
  };

  return tags?.length ? (
    <div className={css.tagsSectionWrapper}>
      <Text
        size="small"
        weight="normal"
        dataHook={DataHooks.DescriptionTagsTitle}
      >
        {t('app.template-page.description.tags-title')}
      </Text>
      <div data-hook={DataHooks.TagListWrapper} className={css.tagsListWrapper}>
        {tags?.map((tag: TemplateTag, tagIndex) => (
          <React.Fragment key={tag.title}>
            <TextButton
              dataHook={DataHooks.TemplateTag(tagIndex)}
              size="tiny"
              weight="thin"
              disabled={!tag?.url}
              onClick={() => {
                onTagClicked(tag);
              }}
            >
              {tag.title}
            </TextButton>
            {tagIndex < tags.length - 1 && <div className={css.tagDivider} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  ) : null;
};
